import React from "react";
import { BrandingValuesForm as BrandingValuesFormDefinition } from "./BrandingValuesForm";

export const BrandingValuesForm = React.memo(BrandingValuesFormDefinition);
